import { Component, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './cookies.component.html',
})
export class CookiesComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Cookie-Richtlinie · Craftly',
      description: 'Informationen zu Cookies und vergleichbaren Speichertechnologien auf Craftly.',
      path: '/cookies',
      type: 'article',
    });
  }
}
